

// ─────────────────────────────────────────────────────────────────────────────
// File: components/weather/DailySummary.jsx
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import { median, msToKnots, formatNum } from './utils';

export default function DailySummary({ rows }) {
  if (!rows?.length) return null;
  const waves = rows.map((r) => r.waveHeight_m).filter(Number.isFinite);
  const swells = rows.map((r) => r.swellHeight_m).filter(Number.isFinite);
  const periods = rows.map((r) => r.swellPeriod_s).filter(Number.isFinite);
  const winds = rows.map((r) => r.windSpeed_ms).filter(Number.isFinite);

  const waveHeight_max_m = waves.length ? Math.max(...waves) : null;
  const waveHeight_avg_m = waves.length ? waves.reduce((a, b) => a + b, 0) / waves.length : null;
  const swellHeight_avg_m = swells.length ? swells.reduce((a, b) => a + b, 0) / swells.length : null;
  const swellPeriod_med_s = periods.length ? median(periods) : null;
  const windSpeed_max_ms = winds.length ? Math.max(...winds) : null;

  const Card = ({ title, main, sub }) => (
    <div style={{ padding: 12, borderRadius: 12, background: '#efe3ef' }}>
      <div style={{ fontSize: 22, color: '#374151' }}>{title}</div>
      <div style={{ fontSize: 22, fontWeight: 700 }}>{main}</div>
      {sub && <div style={{ fontSize: 14, color: '#6b7280' }}>{sub}</div>}
    </div>
  );

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12, marginBottom: 20 }}>
      <Card title="Vagues max" main={`${formatNum(waveHeight_max_m)} m`} sub={`moy. ${formatNum(waveHeight_avg_m)} m`} />
      <Card title="Houle moy." main={`${formatNum(swellHeight_avg_m)} m`} sub={`période médiane ${formatNum(swellPeriod_med_s)} s`} />
      <Card title="Vent max"   main={`${formatNum(msToKnots(windSpeed_max_ms))} nds`} sub={`(${formatNum(windSpeed_max_ms)} m/s`}  />
    </div>
  );
}